import React, { useEffect, useRef, useState } from 'react';
import { CDARedactor } from './CDARedactor/CDARedactor';
import { StructureXPathes } from './StructureXPathes/StructureXPathes';

import s from './TreatmentCDA.module.scss';
import { useAppSelector } from '../../../../../core/redux';
const initialWidth = '50%';
export const TreatmentCDA = () => {
  const sidebarRef = useRef(null);
  const [isResizing, setIsResizing] = useState(false);
  const [sidebarWidth, setSidebarWidth] = useState<string | number>(initialWidth);
  const { isFullScreen } = useAppSelector((state) => state.tablesSlice);
  const startResizing = React.useCallback((e) => {
    e.preventDefault();
    setIsResizing(true);
  }, []);

  const stopResizing = React.useCallback(() => {
    setIsResizing(false);
  }, []);
  const appSidebar = document.querySelector('.app-sidebar');
  const xPathesWrapper = document.querySelector('#xPathesWrapper');
  const resize = React.useCallback(
    (mouseMoveEvent) => {
      if (isResizing) {
        const calcWidth = xPathesWrapper?.getBoundingClientRect().width + 50;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        appSidebar.style.setProperty('--appSidebarWidth', calcWidth + 'px');
        const xPathesWrapperWidth = appSidebar?.getBoundingClientRect().width + 50;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        xPathesWrapper.style.setProperty('--xPathesWrapperWidth', xPathesWrapperWidth + 'px');
        setSidebarWidth(mouseMoveEvent.clientX - sidebarRef.current.getBoundingClientRect().left);
      }
    },
    [isResizing],
  );

  useEffect(() => {
    window.addEventListener('mousemove', resize);
    window.addEventListener('mouseup', stopResizing);

    return () => {
      window.removeEventListener('mousemove', resize);
      window.removeEventListener('mouseup', stopResizing);
    };
  }, [resize, stopResizing]);
  const container = document.querySelector('div[id*=panel-CDA]');

  useEffect(() => {
    if (isFullScreen) {
      container?.classList.add('fullScreen');
    } else {
      container?.classList.remove('fullScreen');
      setSidebarWidth(initialWidth);
    }
  }, [isFullScreen, container]);

  return (
    <div id={'CDAInitHeight'} className={s.TreatmentCDA}>
      <div id={'CDA_content'} className={`${s.content} app-container`}>
        <div ref={sidebarRef} className='app-sidebar' style={{ width: sidebarWidth }}>
          <div className='app-sidebar-content'>
            <div id={'CDARedactorWrapper'} className={s.CDARedactorWrapper}>
              <CDARedactor />
            </div>
          </div>
        </div>
        <div className='app-sidebar-resizer' onMouseDown={startResizing} />

        <div id={'xPathesWrapper'} className={`${s.xPathesWrapper} app-frame`}>
          <StructureXPathes />
        </div>
      </div>
    </div>
  );
};
